import { FC, useState } from 'react';

import { Button, Empty, Flex, Modal, Row, TabsProps, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import IconDownload from '@/assets/icons/icon-download.svg?react';
import IconInfo from '@/assets/icons/icon-info.svg?react';
import Card from '@/components/RCard';
import PageHeader from '@/components/RPageHeader';
// import paths from '@/routes/paths';
import CustomTab from '@/components/RTab';
import Table from '@/components/RTable';
import RTag from '@/components/RTag';
import { CreditCard, Payment } from '@/types/payment';

import PlansModal from './PlansModal';
import StyledUserManagement from './styles';

const Payments: FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { t } = useTranslation();

  const tableDataSource: Payment[] = []; //todo change this
  const cardsDataSource: CreditCard[] = []; //todo change this
  // const billingAddressDataSource: CreditCard[] = []; // TODO change this
  //const { user } = useAuth();
  const theme = useTheme();

  // const handleRenewClick = () => {
  //   setIsModalVisible(true);
  // };

  // Function to handle modal close
  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const getDataIndex = (dataIndex: string) => {
    switch (dataIndex) {
      case 'SUCCESS':
        return <RTag type={'success'} />;
      case 'FAILURE':
        return <RTag type={'failure'}>{dataIndex}</RTag>;
      case 'REVOKED':
        return <RTag type={'revoked'}>{dataIndex}</RTag>;
      case 'INACTIVE':
        return <RTag type={'inactive'}>{dataIndex}</RTag>;
      case 'ACTIVE':
        return <RTag type={'active'}>{dataIndex}</RTag>;
      default:
        return (
          <RTag type={'default'} style={{ margin: '0' }}>
            {' '}
            {dataIndex.toLocaleUpperCase()}
          </RTag>
        );
    }
  };

  const paymentsTableColumn: ColumnsType<Payment> = [
    {
      title: t('organization.payments.table.invoiceDate'),
      dataIndex: 'invoiceDate',
      key: 'invoiceDate',
      sorter: (a, b) =>
        dayjs(a.invoiceDate).unix() - dayjs(b.invoiceDate).unix(),
      render: (dataIndex) => dayjs(dataIndex).format('DD.MM.YYYY HH:mm'),
    },
    {
      title: t('organization.payments.table.amount'),
      dataIndex: 'amount',
      key: 'amount',
      sorter: (a, b) => a.amount - b.amount,
      render: (text, record) => record.unit + text,
    },
    {
      title: t('organization.payments.table.paymentDate'),
      dataIndex: 'datePayment',
      key: 'amount',
      sorter: (a, b) =>
        dayjs(a.datePayment).unix() - dayjs(b.datePayment).unix(),
      render: (dataIndex) => dayjs(dataIndex).format('DD.MM.YYYY HH:mm'),
    },
    {
      title: t('organization.payments.table.status'),
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (dataIndex) => getDataIndex(dataIndex),
    },
    {
      title: t('organization.payments.table.downloadInvoice'),
      dataIndex: 'downloadInvoice',
      key: 'downloadInvoice',
      align: 'center',
      render: () => (
        <Button
          type="default"
          style={{
            padding: '6px 8px',
            borderColor: theme.colors.grayLightAccent,
          }}
        >
          <IconDownload fill={theme.colors.bluePrimary} />
        </Button>
      ),
    },
  ];

  const EmptyInfo = (
    <Empty
      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
      styles={{ image: { height: 100 } }}
      description={t('organization.payments.emptyState.noDataFound')}
    >
      <Typography.Paragraph className="smoke fs-12">
        {t('organization.payments.emptyState.underDevelopment')}
      </Typography.Paragraph>
    </Empty>
  );

  const renewCard = (
    <Card $paddingBody="32px" className="mt-24">
      <Flex vertical gap={16} align="center" justify="center">
        <Flex gap={8} align="center" justify="center">
          <IconInfo fill={theme.colors.bluePrimary} />
          <Typography.Text className="renew-text">
            {t('organization.payments.renewCard.title')}
          </Typography.Text>
        </Flex>
        {/* <Button
      type="primary"
      className="renew-btn"
      onClick={handleRenewClick}
    >
      {t('organization.payments.renewCard.renewButton')}
    </Button> */}
      </Flex>
    </Card>
  );

  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: t('organization.payments.tabs.paymentHistory'),
      children: (
        <>
          {renewCard}
          <Card
            title={t('organization.payments.tabs.paymentHistory')}
            className="mt-24"
          >
            <Table
              rowKey="id"
              rowClassName="cursor-pointer"
              cta={
                <Typography.Paragraph className="smoke fs-12">
                  {t('organization.payments.emptyState.underDevelopment')}
                </Typography.Paragraph>
              }
              columns={paymentsTableColumn}
              dataSource={tableDataSource}
              pagination={false}
              /*  pagination={{
        total: paginationData?.count,
        onChange: (page) => { setPageNo(page) },
         }} */
            />
          </Card>
        </>
      ),
    },
    {
      key: '2',
      label: t('organization.payments.tabs.savedCards'),
      children: (
        <>
          {renewCard}
          <Card $paddingBody="24px" className="mt-24">
            <Row>
              <Typography.Title level={5} className="saved-title">
                {t('organization.payments.savedCard.title')}
              </Typography.Title>
            </Row>
            <Flex gap={24} justify="center">
              {cardsDataSource.length !== 0 ? <>{/** TODO */}</> : EmptyInfo}
            </Flex>
          </Card>
        </>
      ),
    },
    {
      key: '3',
      label: t('organization.payments.tabs.billingAddress'),
      children: (
        <>
          {renewCard}
          <Card $paddingBody="24px" className="mt-24">
            <Row>
              <Typography.Title level={5} className="saved-title">
                {t('organization.payments.billingAddress.title')}
              </Typography.Title>
            </Row>
            <Flex gap={24} justify="center">
              <>{EmptyInfo}</>
            </Flex>
          </Card>
        </>
      ),
    },
  ];
  return (
    <StyledUserManagement>
      <PageHeader
        title={t('organization.payments.pageTitle')}
        description={t('organization.payments.pageDescription')}
      />

      <CustomTab items={tabItems}></CustomTab>

      <Modal
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        destroyOnClose
        centered
        width={'100%'}
      >
        <PlansModal />
      </Modal>
    </StyledUserManagement>
  );
};

export default Payments;
